module.exports = __webpack_public_path__ + "img/saved-empty.d19598ef.svg";